module.exports = __webpack_public_path__ + "img/white-curved.4206ea0b.jpeg";